import _ from 'lodash'
import router from '../router'
import axios from 'axios'
import qs from 'qs'
import store from '../store'
import { Message } from 'element-ui'
import __ from '@/util/common-utils'
// import host from '../../config/host'
const EASY_MOCK_BASE =
  'http://192.168.120.194:7300/mock/600155542c7cf895bc0c4995'
let base = ''
if (process.env.NODE_ENV !== 'development') {
  if (process.env.NODE_HOST && process.env.NODE_HOST !== 'null') {
    base = `${process.env.NODE_PROTOCOL}://${process.env.NODE_HOST}`
  } else {
    base =
      process.env.NODE_IP !== 'null' && process.env.NODE_PORT !== 'null'
        ? `${process.env.NODE_PROTOCOL}://${process.env.NODE_IP}:${process.env.NODE_PORT}`
        : window.location.origin
  }
} else {
  console.log('> axios base >>> ' + base)
}
const ERROR_CODES = {
  PRIMARY_INDICATORS_NAME_EXISTS: '指标名称已存在',
  PRIMARY_INDICATORS_NUM_OVERLIMIT: '可以不处理，页面上添加10个后按钮变灰',
  SECONDARY_INDICATORS_NAME_EXISTS: '指标名称已存在',
  EVALUATION_TASK_ALREADY_PUBLISH: '年级评价已发布',
  INDICATORS_NOT_FILED: '指标未存档',
  INDICATORS_TASK_NOT_PUBLISH: '年级评价尚未发布',
  INDICATORS_TASK_PUBLICITY_ALREADY_PUBLISH: '年级评价公告已发布',
  EVALUATION_CLASS_NO_ALREADY:
    '存在未完成等第评价或教师评语的学生，请完成后再提交',
  FILE_UPLOAD_ERROR: '文件上传失败',
  CURRENT_TERM_NOT_EXISTS: '当前学期获取失败',
  REPORT_IS_NOT_EXISTS: '报告不存在',
  FILE_DOWNLOAD_ERROR: '文件下载失败',
  empty_institution: '请先添加机构',
  REPORT_NOT_GENERATE: '暂无可下载的评价报告，请稍后再试',
  EVALUATION_GRADE_NO_ALREADY:
    '当前仍有班级未提交评价结果，无法进行评价公示提交',
  QUALITY_CLASS_NO_ALREADY:
    '存在未完成等第评价或教师评语的学生，请完成后再提交',
  QUALITY_GRADE_NO_ALREADY: '当前仍有班级未提交评价结果，无法进行存档',
  all_done: '所有学生均已完成户籍信息导入'
}

export const isTimeIntervalOverHalfOneHour = (time1, time2) => {
  if (time1 && time2) {
    if (Math.abs(time1 - time2) > 30 * 60 * 1000) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const isTimeIntervalOverOneHour = (time1, time2) => {
  if (time1 && time2) {
    if (Math.abs(time1 - time2) > 60 * 60 * 1000) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const requestNewToken = () => {
  const param = {
    client_id: 'test',
    client_secret: 'MTIzNDU2',
    grant_type: 'refresh_token',
    refresh_token: localStorage.getItem('refreshToken')
  }
  return axios.post('/auth/oauth/token', qs.stringify(param), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  })
}

/**
 * Had to use `defaults` to make timeout work.
 * see: https://github.com/axios/axios/issues/1503
 * see: https://github.com/axios/axios/issues/647
 */
axios.defaults.timeout = 10 * 1000
axios.defaults.headers.post = {
  'Content-Type': 'application/json; charset=UTF-8'
}
axios.defaults.headers.put = {
  'Content-Type': 'application/json; charset=UTF-8'
}
axios.defaults.headers.patch = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}

// let sessionTimeOutTimestamp = new Date().getTime()

let pageLoadingTime = localStorage.getItem(window.location.href)

if (!pageLoadingTime) {
  pageLoadingTime = new Date().getTime()
  localStorage.setItem(window.location.href, pageLoadingTime)
}

let timeout = null
const messageTimeout = function(type, message) {
  if (timeout) {
    window.clearTimeout(timeout)
    timeout = null
  }
  timeout = setTimeout(() => {
    Message[type]({ message })
  }, 500)
}

// 记录 请求token接口时间、上一次请求时间
// eslint-disable-next-line
var requestTokenTime = Number(localStorage.getItem("requestTokenTime")) || null
// eslint-disable-next-line
var lastRequestTime = Number(localStorage.getItem("lastRequestTime")) || null

axios.interceptors.request.use(
  config => {
    let url = config.url
    let now = null

    const noRestrict =
      url === `${base}/oauth/token` ||
      url === `${base}/register` ||
      url === `${base}/send-msg` ||
      url === `${base}/verification` ||
      url === `${base}/password` ||
      url === `${base}/whoami`
    // 登录/注册/发送验证码接口请求不限制以解决请求接口跳转登录问题
    // 大屏接口解除限制
    // 验证验证码/重置密码接口解除限制
    if (noRestrict) {
      return config
    } else {
      now = new Date().getTime()
      if (url.indexOf('/oauth/token') !== -1) {
        requestTokenTime = new Date().getTime()
        localStorage.setItem('requestTokenTime', requestTokenTime)
      }
    }
    // if (!isLoggedUser()) {
    //   let nowTime = new Date().getTime()
    //   /* check to only reload once in 10s, as a page may have multi ajax requests */
    //   if (nowTime - pageLoadingTime > TEN_SECONDS) {
    //     console.log('login info invalid...', nowTime, pageLoadingTime, nowTime - pageLoadingTime, '登录信息已过期')
    //     pageLoadingTime = nowTime
    //     localStorage.setItem(window.location.href, pageLoadingTime)
    //     Message.error({ message: '登录信息已过期，请等待页面刷新后重试...' })
    //     setTimeout(redirectLogin, 500)
    //     /* return empty would **prevent** this ajax reqeust with error, How about using cancel token */
    //     return
    //   }
    // }
    // 判断token是否存在
    let token = localStorage.getItem('token')
    if (
      token &&
      (url !== `${base}/acc/sms/code/anon` &&
        url !== `${base}/acc/password/anon` &&
        url.indexOf('/student-file') === -1)
    ) {
      // 将token设置成请求头
      config.headers.common['Authorization'] = 'Bearer ' + token
    } else {
      config.headers.common['Authorization'] = ''
    }

    if (url === '/acc/user/logout') {
      localStorage.clear()
      store.commit('user/logout')
      router.push({ name: 'Login' })
      return config
    }

    // 现在请求的时间跟请求token接口时间对比
    // 如果超过半小时，再对比上一次请求时间
    // 如果超过一小时，则直接跳到登录，反之拿到新token
    console.log('上次请求的时间是: ' + __.fomartDate(lastRequestTime))
    console.log('现在的时间是: ' + __.fomartDate(now))
    console.log('请求token的时间是: ' + __.fomartDate(requestTokenTime))
    if (isTimeIntervalOverHalfOneHour(now, requestTokenTime)) {
      if (isTimeIntervalOverOneHour(now, lastRequestTime)) {
      } else {
        requestTokenTime = new Date().getTime()
        localStorage.setItem('requestTokenTime', requestTokenTime)
        if (!noRestrict) {
          lastRequestTime = new Date().getTime()
          localStorage.setItem('lastRequestTime', lastRequestTime)
        }
      }
    } else {
      if (!noRestrict) {
        lastRequestTime = new Date().getTime()
        localStorage.setItem('lastRequestTime', lastRequestTime)
      }
    }

    return config
  },
  err => {
    console.log(err)
    // Message.error({ message: '请求异常' })
    messageTimeout('error', '请求异常')
  }
)

/** 200 response, but also has follow critical errors. */
// const GLOBAL_RS_CODE = { 403: '暂无权限', 400: '非法请求', 500: '服务异常，请联系管理员获取支持' }

axios.interceptors.response.use(
  resp => {
    if (resp.status && resp.status === 200) {
      let rs = resp.data
      const content = resp.headers['content-disposition']
      if (content && content.includes('filename')) {
        const arr = content.split('filename=')
        rs.filename = decodeURI(arr[1])
      }
      let msg = ERROR_CODES[rs.code]
      if (msg) {
        // Message.error({ message: msg })
        messageTimeout('error', msg)
        return rs
      }
      return rs
    }
  },
  err => {
    if (err.message === 'Network Error') {
      // Message.error({ message: '网络异常，请重新登录' })
      messageTimeout('error', '网络异常，请重新登录')
      router.push({ name: 'Login' })
    } else if (err.message.includes('timeout')) {
      // Message.error({ message: '请求超时' })
      messageTimeout('error', '请求超时')
    } else if (err.response.status === 401) {
      /* avoid multi Message Box alerts */
      // let tmpSessionTimeOutTimestamp = new Date().getTime()
      // if (tmpSessionTimeOutTimestamp - sessionTimeOutTimestamp > 10 * 1000) {
      //   sessionTimeOutTimestamp = tmpSessionTimeOutTimestamp
      //   Message.error({ message: '会话过期，请重新登录' })
      // }
      if (
        err.response.data.error &&
        (err.response.data.error === 'invalid_token' ||
          err.response.data.error === 'invalid_user_token' ||
          (err.response.data.message &&
            err.response.data.message === 'invalid_token'))
      ) {
        // Message.error({ message: '会话过期，请重新登录' })
        messageTimeout('error', '会话过期，请重新登录')
      }
      router.push({ name: 'Login' })
    } else {
      const resData = err.response.data
      if (
        Object.prototype.toString.call(resData) === '[object Object]' &&
        'code' in resData &&
        ERROR_CODES[resData.code]
      ) {
        messageTimeout('error', ERROR_CODES[resData.code])
      } else {
        messageTimeout('error', '未知错误，请联系管理员')
        // Message.error({ message: '未知错误，请联系管理员' })
      }
    }
    return err.response.data
  }
)

/**
 * Delegate `axios.get` with hidden the `config.params` option. `params` must be JSON object.
 */
export const xhrGet = (url, params, config) => {
  return axios.get(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    _.isNil(params) ? config : _.merge({}, { params: params }, config)
  )
}

const QS_STRINGIFY_OPTION = { skipNulls: true, indices: false }

/**
 * Delegate `axios.post`. `data` must be JSON object.
 * @param url post url
 * @param data form object
 * @param config axios config
 * @param qsOptions qs.stringfy options
 */
export const xhrPost = (url, data, config, qsOptions) => {
  return axios.post(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    data,
    config
  )
}

/**
 * Delegate `axios.put`. `data` must be JSON object.
 */
export const xhrPut = (url, data, config) => {
  return axios.put(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    data,
    config
  )
}

/**
 * Delegate `axios.patch`. `data` must be JSON object.
 */
export const xhrPatch = (url, data, config) => {
  return axios.patch(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    qs.stringify(data, QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.delete`.
 */
/* export const xhrDelete = (url, data, config) => {
  return axios.delete(`${getMock(config) ? EASY_MOCK_BASE : base}${url}`, {
    params: data,
    paramsSerializer: params => qs.stringify(params, { indices: false }),
    ...config
  })
} */
export const xhrDelete = (url, data, config) => {
  if (data && data.hasArray) {
    return axios.delete(`${getMock(config) ? EASY_MOCK_BASE : base}${url}`, {
      params: data,
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...config
    })
  } else {
    return axios.delete(`${getMock(data) ? EASY_MOCK_BASE : base}${url}`, data)
  }
}

export const xhrFilePost = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.post(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    data,
    config
  )
}

export const xhrFilePut = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.put(
    `${getMock(config) ? EASY_MOCK_BASE : base}${url}`,
    data,
    config
  )
}

export const isLoggedUser = () => {
  let user = store.state.access_token
  console.log(document.cookie)
  let accessToken = (
    document.cookie.match('(^|[^;]+)\\s*' + 'sso-token' + '\\s*=\\s*([^;]+)') ||
    []
  ).pop()
  if (user && user.token && user.token === accessToken) {
    return true
  }
  return false
}

export const fetchFile = (url, params, config) => {
  axios
    .get(
      `${base}${url}`,
      _.isNil(params)
        ? { ...config, timeout: 60 * 1000 }
        : _.merge(
            {},
            { params: params },
            { responseType: 'blob', timeout: 60 * 1000 }
          )
    )
    .then(rs => {
      if (rs.error === 'invalid_token') {
        // Message.error({ message: '下载模板失败' })
        messageTimeout('error', '下载模板失败')
        return false
      }
      if (
        ![
          'application/msexcel',
          'application/octet-stream',
          'application/pdf'
        ].includes(rs.type)
      ) {
        var enc = new TextDecoder('utf-8')
        rs.arrayBuffer().then(buffer => {
          let data = JSON.parse(enc.decode(new Uint8Array(buffer))) || {}
          if ('code' in data && ERROR_CODES[data.code]) {
            messageTimeout('error', ERROR_CODES[data.code])
          } else {
            messageTimeout('error', '未知错误，请联系管理员')
          }
        })
        return false
      }
      let blob = new Blob([rs])
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      // AXIOS暂无法获取rs.headers，前端写死文件名
      link.download =
        params && params.name ? params.name + '.xlsx' : decodeURIComponent(rs.filename)
      link.click()
    })
    .catch(err => {
      console.log(err)
    })
}

export const fetchPdf = (url, params, config) => {
  xhrGet(`${url}`, params).then(res => {
    if (res.code === 'SUCCESS') {
      // const splitMark = '/student-file'
      // const targetPath = splitMark + res.data.filePath.split(splitMark)[1]
      axios
        .get(`${res.data.filePath}`, { responseType: 'blob' })
        .then(rs => {
          if (rs.error === 'invalid_token') {
            // Message.error({ message: '下载模板失败' })
            messageTimeout('error', '下载模板失败')
            return false
          }
          if (
            ![
              'application/msexcel',
              'application/pdf',
              'application/zip',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/octet-stream'
            ].includes(rs.type)
          ) {
            var enc = new TextDecoder('utf-8')
            try {
              let fileReader = new FileReader()
              fileReader.readAsArrayBuffer(rs)
              fileReader.onload = function() {
                let arrayBuffer = fileReader.result
                let data =
                  JSON.parse(enc.decode(new Uint8Array(arrayBuffer))) || {}
                if ('code' in data && ERROR_CODES[data.code]) {
                  messageTimeout('error', ERROR_CODES[data.code])
                } else {
                  messageTimeout('error', '未知错误，请联系管理员')
                }
              }
            } catch (error) {
              console.log(error)
            }
            return false
          }
          let blob = new Blob([rs])
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = res.data.fileName
          link.click()
        })
        .catch(err => {
          console.log(err)
        })
    }
  })
}

/**
 * @param {Object} config 请求配置对象
 * @description
 *  获取配置对象中的isMock状态，不设置isMock则默认为false
 */
function getMock(config) {
  let res = false
  if (config && 'isMock' in config) {
    res = config.isMock
    delete config.isMock
  }
  return res
}



// WEBPACK FOOTER //
// ./src/util/xhr-apis.js